import PurchaseCompleteContainer from './PurchaseCompleteContainer';

export default PurchaseCompleteContainer;
